<template>
  <v-layout class="column container">
		<div class="third-route-title">{{getStateWithParam('terms_label')}}</div>
		<div class="terms-box-wrapper">
			<iframe
				scrolling="yes"
				style="overflow: hidden"
				class="terms-iframe lazyload"
				:src="url"
				frameborder="0"
			/>
		</div>
	</v-layout>
</template>

<script>
import { TERMS_CONDITIONS_URL } from "@/config/api/url/urls_in_app";
export default {
	computed: {
		url(){
			let type_language = this.$store.state.type_language
			return TERMS_CONDITIONS_URL[type_language]
		}
	},
	created() {
		this.$store.state.active_loader = false;
	},
	methods: {
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		}
	}
};
</script>


<style scoped lang="scss" src="./TermsAndConditions.scss">
</style>
